import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { BootstrapInput } from "../../../../../../../../components/widgets/BootstrapInput";
import { getMrqData } from "../../api";

const MrqSelector = ({
  mrqList,
  mrqSelection,
  setMrqSelection,
  setSelectedMrqData,
}) => {
  const handleMrqChange = async (event) => {
    const mrqId = event.target.value;
    const selectedMrq = mrqList.find((mrq) => mrq.id === mrqId);
    const revisions = selectedMrq?.revs ? selectedMrq.revs : [];

    setMrqSelection({
      selectedMrq: mrqId,
      revisions: revisions,
      selectedRevision: "",
    });

    try {
      const data = await getMrqData(mrqId);
      // console.log(data);
      setSelectedMrqData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRevisionChange = (event) => {
    setMrqSelection({ ...mrqSelection, selectedRevision: event.target.value });
  };

  // console.log("New mrq selection:", mrqSelection);

  const revs =
    mrqSelection?.revisions?.length &&
    typeof mrqSelection?.revisions === "string"
      ? JSON.parse(mrqSelection?.revisions)
      : mrqSelection?.revisions;

  console.log("revvvs", revs);

  return (
    <>
      <FormControl
        variant="standard"
        size="small"
        sx={{ m: 1, ml: 0, mt: 0, minWidth: 120 }}
      >
        <InputLabel id="mrq-label" shrink sx={{ fontSize: "1.1rem" }}>
          MRQ Number
        </InputLabel>
        <Select
          labelId="mrq-label"
          value={mrqSelection.selectedMrq}
          onChange={handleMrqChange}
          label="Mrq"
          size="small"
          input={<BootstrapInput />}
        >
          {mrqList.map((mrq) => (
            <MenuItem key={mrq.id} value={mrq.id}>
              {mrq.mrqNumber}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        variant="standard"
        size="small"
        sx={{ m: 1, ml: 0, mt: 0, minWidth: 120 }}
      >
        <InputLabel id="revision-label" shrink sx={{ fontSize: "1.1rem" }}>
          Revision
        </InputLabel>
        <Select
          labelId="revision-label"
          value={mrqSelection.selectedRevision}
          defaultValue={mrqSelection.revisions[0]?.revId}
          onChange={handleRevisionChange}
          disabled={!mrqSelection.selectedMrq}
          label="Revision"
          input={<BootstrapInput />}
        >
          {revs?.map((rev) => (
            <MenuItem key={rev.revId} value={rev.revId}>
              {rev.revName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default MrqSelector;
